<template>
<div class="ls-body">
    <base-car-list :sourceList="recommandList"/>
</div>
</template>

<script>
import BaseCarList from './baseCarList'
import { getUsedCarList } from '../../api'
export default {
  components: {
      BaseCarList
  },
  props: {
    hiddenFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      recommandList: []
    };
  },
  watch: {},
  computed: {
  },
  methods: {
    async loadRecommandCars(){
        const ret = await getUsedCarList({page: 1, rows: 5, qc_status: 1})
        if(ret.code === 0){
          this.recommandList = ret.data.records
        }
    }
  },
  beforeCreate() {},
  created() {},
  async mounted() {
      await this.loadRecommandCars()
  }
};
</script>
<style lang="scss" scoped>
.ls-body{
    padding: 0rem .3rem;
    .filter{
        display: flex;
        font-size: .23rem;
        color:#6a6a6a;
        height: .5rem;
        .ft{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: .5rem;
        }
        i{
            display: inline-block;
            width: 0px;
            height: 0px;
            border: .08rem solid transparent;
            border-top: .08rem solid #6a6a6a;
            position: relative;
            top: .05rem;
            margin-left: .07rem;
        }
        .ft-name,.ft-brand.ft-price{
            display: inline-block;
        }
    }
}
</style>